<template>
  <v-card flat>
    <v-app-bar fixed height="150" class="pa-0 ma-0" color="white">
      <v-card class="ma-0" width="100%" color="transparent" flat dense>
        <v-toolbar dense flat  color="transparent">
        <v-spacer></v-spacer>
        <v-btn
          disabled
          small
          text
          color="primary"
          >Actividades</v-btn
        >
        |
        <v-btn
          disabled
          small
          text
          color="primary"
          >Profesores</v-btn
        >
        |
        <v-btn
          small
          text
          @click="$emit('students')"
          color="primary"
          >Alumnos</v-btn
        >
        <v-spacer></v-spacer>
      </v-toolbar>
    <v-toolbar flat dense color="transparent">
      <v-text-field
        v-model="search"
        class="mx-0 px-0 pt-8"
        rounded
        outlined
        filled
        dense
        append-icon="mdi-magnify"
        placeholder="Buscar actividad"
      >
      </v-text-field>
    </v-toolbar>
    <v-toolbar flat dense color="transparent">
      <v-spacer></v-spacer>
      <v-dialog v-model="newActivityDialog" width="700">
        <template v-slot:activator="{ on }" class="ma-0 pa-0">
          <v-btn text rounded v-on="on" color="primary" class="pa-0 px-2 ma-0">
            <v-icon left>mdi-plus</v-icon>Nueva actividad
          </v-btn>
        </template>
        <v-card>
          <v-card-title
            >{{ newActivity.id ? newActivity.name : "Nueva actividad" }}
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Nombre de la actividad"
              v-model="newActivity.name"
            ></v-text-field>
            <v-combobox
              label="Niveles"
              multiple
              v-model="newActivity.target"
              @change="changeTarget()"
              hint="Ejemplo: 023A"
            >
              <template v-slot:selection="data">
                <v-chip
                  :key="JSON.stringify(data.item)"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
            </v-combobox>
            <!--<v-select
              label="Sugerencias"
              multiple
              v-model="newActivity.hints"
            ></v-select>-->
            <v-row>
              <v-col cols="3">
                <v-checkbox
                  label="Prodet"
                  v-model="newActivity.prodet"
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  type="number"
                  label="Grupo mínimo"
                  v-model="newActivity.min"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  type="number"
                  label="Plazas"
                  v-model="newActivity.max"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  type="number"
                  label="Precio"
                  append-icon="mdi-currency-eur"
                  v-model="newActivity.price"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-textarea
              v-model="newActivity.description"
              label="Descripción"
              rows="4"
            ></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text @click="cancelEditActivity">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="createActivity">{{
              newActivity.id ? "Confirmar cambios" : "Añadir actividad"
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
    </v-toolbar>
      </v-card>
    </v-app-bar>
    <v-card-text :style="{'margin-top': '140px'}">
      <v-card
        color="lighten-4"
        class="mx-0 my-3"
        :key="index"
        v-for="(activity, index) in $store.state.activities.filter(matchSearch)"
        @click="$emit('select', activity)"
      >
        <v-card-text class="pa-2 pl-3">{{ activity.name }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions color="accent">
          <v-subheader>{{ Object.keys(activity.groups).length }} {{ Object.keys(activity.groups).length !== 1 ? 'grupos' : 'grupo' }} <v-icon small>mdi-slash-forward</v-icon> {{ getStudents(activity) }} {{ getStudents(activity) !== 1 ? 'alumnos' : 'alumno' }}</v-subheader>
          <v-spacer></v-spacer>
          <v-btn
            icon
            x-small
            @click.stop="
              activityToDelete = activity;
              deleteActivityDialog = true;
            "
            color="accent"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            icon
            x-small
            @click.stop="cloneActivity(activity)"
            color="accent"
          >
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
          <v-btn icon x-small @click="editActivity(activity)" color="accent">
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="deleteActivityDialog" width="300">
        <v-card>
          <v-toolbar flat class="pa-0 ma-0">
            <v-card-title>Eliminar actividad</v-card-title>
          </v-toolbar>
          <v-card-text class="pa-2">
            ¿Seguro que quieres eliminar está actividad?
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              text
              @click="(deleteActivityDialog = false), (activityToDelete = {})"
              >Cancelar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="deleteActivity">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
/*jshint esversion: 6 */
/*eslint-disable no-console*/
import { newId, normalize, activities } from "../firebaseConfig.js";
export default {
  components: {},
  data() {
    return {
      search: '',
      activityToDelete: {},
      newActivity: {},
      newActivityDialog: false,
      deleteActivityDialog: false,
      targets: ["032A", "032B", "032C"],
    };
  },
  created() {},
  methods: {
    matchSearch(activity) {
      return normalize(activity.name).includes(normalize(this.search)) || activity.target.indexOf(this.search)>=0;
    },
    getStudents(activity) {
      let result = 0;
      Object.values(activity.groups || {}).forEach((group)=>{
        result += Object.keys(group.students).length;
      });
      return result;
    },
    deleteActivity() {
      activities
        .doc(this.activityToDelete.id)
        .delete()
        .then(() => {
          this.deleteActivityDialog = false;
          this.$emit("deleted", this.activityToDelete);
          this.activityToDelete = {};
        });
    },
    cloneActivity(activity) {
      let id = newId();
      let groups = {};
      Object.values(activity.groups).forEach((group) => {
        let groupId = newId();
        let theGroup = {
          ...group,
          id: groupId,
          students: {},
        };
        groups[theGroup.id] = theGroup;
      });
      let newActivity = {
        ...activity,
        id,
        groups,
        published: false,
        name: activity.name + " (copia)",
      };
      activities.doc(newActivity.id).set(newActivity);
    },
    changeTarget() {
      this.newActivity.targets = [];
      this.newActivity.target.forEach((target) => {
        if (target.length === 2) {
          let levels = 0;
          switch (target) {
            case "00":
              levels = 5;
              break;
            case "01":
              levels = 6;
              break;
            case "02":
              levels = 4;
              break;
            case "03":
              levels = 2;
              break;
            case "04":
              levels = 4;
              break;
            case "05":
              levels = 4;
              break;
          }
          for (let i = 1; i <= levels; i++) {
            ["A", "B", "C", "D", "E", "F"].forEach((line) => {
              this.newActivity.targets.push(target + i + line);
            });
          }
        }
        if (target.length === 3) {
          ["A", "B", "C", "D", "E", "F"].forEach((line) => {
            this.newActivity.targets.push(target + line);
          });
        }
        if (target.length === 4) {
          if (isNaN(target[target.length - 1])) {
            this.newActivity.targets.push(target.toUpperCase());
          } else {
            for (let i = parseInt(target[2]); i <= parseInt(target[3]); i++) {
              ["A", "B", "C", "D", "E", "F"].forEach((line) => {
                this.newActivity.targets.push(
                  target.substring(0, 2) + i + line
                );
              });
            }
          }
        }
        if (target.length === 5) {
          for (let i = parseInt(target[2]); i <= parseInt(target[3]); i++) {
            this.newActivity.targets.push(
              target.substring(0, 2) + i + target[4].toUpperCase()
            );
          }
        }
      });
    },
    editActivity(activity) {
      this.newActivity = activity;
      this.newActivityDialog = true;
    },
    cancelEditActivity() {
      this.newActivityDialog = false;
      this.newActivity = {};
    },
    createActivity() {
      let newActivity = {};
      if (this.newActivity.id) {
        newActivity = this.newActivity;
      } else {
        let id = newId();
        newActivity = {
          ...this.newActivity,
          groups: {},
          id,
        };
      }
      activities
        .doc(newActivity.id)
        .set(newActivity)
        .then(() => {
          this.newActivityDialog = false;
          this.newActivity = {};
        })
        .catch(() => {
          this.newActivityDialog = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
